export default __webpack_public_path__ + "1d6dd63431d0513a802909dc1bad3175.png";